import { Skeleton, SkeletonText } from '~/components';

import { cardStyle, contentStyle, skeletonHeaderStyle, skeletonProfilePictureStyle, skeletonTextWrapperStyle } from './ForumComment.css';

export const ForumCommentSkeleton = () => {
  return (
    <Skeleton>
      <article className={cardStyle}>
        <header className={skeletonHeaderStyle}>
          <div className={skeletonProfilePictureStyle} />
          <div className={skeletonTextWrapperStyle}>
            <SkeletonText fontSize="small" lineHeight="snug" width="50%" />
            <SkeletonText fontSize="tiny" width="30%" />
          </div>
        </header>

        <div className={contentStyle}>
          <SkeletonText fontSize="small" />
          <SkeletonText fontSize="small" width="70%" />
        </div>
      </article>
    </Skeleton>
  );
};
